<top-banner variant="title" [title]="pageTitle"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <div class="mb-2 animated fadeIn">
              <ng-container *ngFor="let siteOwnerGroup of siteOwnersList">
                <br>
                <h4 class="card-title">{{ siteOwnerGroup.siteOwnerName }}</h4>
                <h6 class="card-title">Certificates</h6>
                <div class="row">
                  <div class="col-md-12">
                    <p *ngIf="!siteOwnerGroup.competencies.length">
                      No certificates requested by site owner
                    </p>
                    <p-table *ngIf="siteOwnerGroup.competencies.length" [value]="siteOwnerGroup.competencies" [autoLayout]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Files</th>
                          <th>Expiry Date</th>
                          <th></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-comp>
                        <tr [pSelectableRow]="comp">
                          <td>
                            <div>{{ comp.competencyType.value }}</div>
                            <ng-container  *ngIf="siteOwnerGroup.isPowerstationOwner && siteOwnerGroup.powerStationId">
                              <li class="small-data" *ngIf="extraCompetencyInfo[comp.competencyType.id]">{{extraCompetencyInfo[comp.competencyType.id]}}</li>
                            </ng-container>
                          </td>
                          <td>
                            <span *ngIf="comp.status === 'PENDING'" class="badge badge-pill badge-warning">Required</span>
                            <span *ngIf="comp.status === 'EXPIRED'" class="badge badge-pill badge-danger">Expired</span>
                            <span *ngIf="comp.status === 'SUBMITTED'" class="badge badge-pill badge-primary">Submitted</span>
                            <span *ngIf="comp.status === 'APPROVED' && !comp.nearExpiry" class="badge badge-pill badge-success">Approved</span>
                            <span *ngIf="comp.status === 'APPROVED' && comp.nearExpiry" class="badge badge-pill badge-warning">Expires Soon</span>
                            <span *ngIf="comp.status === 'REJECTED'" class="badge badge-pill badge-danger">Rejected</span>
                          </td>
                          <td>
                            <div *ngFor="let file of comp.files" class="button-link-wrapper">
                              <button type="button" class="btn btn-primary btn-link text-left" (click)="viewDocument(file.fileName)">{{ file.fileName }}</button>
                            </div>
                          </td>
                          <td>{{ comp.expiryDate | date: 'MMM d, y'}}</td>
                          <td>
                            <ng-container *ngIf="comp.status === 'APPROVED' && !comp.nearExpiry">
                              <!-- no link -->
                            </ng-container>
                            <ng-container *ngIf="comp.status === 'PENDING'">
                              <button type="button" class="btn btn-primary btn-link" (click)="uploadCertificate(comp)">upload</button>
                            </ng-container>
                            <ng-container *ngIf="comp.status === 'REJECTED' || comp.status === 'SUBMITTED' || comp.status === 'EXPIRED' || (comp.status === 'APPROVED' && comp.nearExpiry)">
                              <button type="button" class="btn btn-primary btn-link" (click)="uploadCertificate(comp)">replace</button>
                            </ng-container>
                          </td>
                        </tr>
                        <tr [pSelectableRow]="comp">
                          <ng-container *ngIf="comp.status === 'REJECTED'">
                            <td colspan="5">
                              <b>Rejection comments:</b> {{comp.rejectionComments}}
                            </td>
                          </ng-container>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                          <td [attr.colspan]="4">No certificates found</td>
                        </tr>
                      </ng-template>
                    </p-table>

                    <!--     OUTAGE ACCEPTANCE    -->
                    <div *ngIf="siteOwnerGroup.isPowerstationOwner">
                      <br/>
                      <h6 class="card-title">Outage Acceptances</h6>
                      <p-table [value]="siteOwnerGroup.outageAcceptances" [autoLayout]="true">
                        <ng-template pTemplate="header">
                          <tr>
                            <th>Acceptance</th>
                            <th>Status</th>
                            <th>Accepted Date</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-outage>
                          <tr [pSelectableRow]="outage">
                            <td>{{ outage.course.trainingName }}<div class="small-data">{{ outage.course.description }}</div></td>
                            <td>
                              <span *ngIf="outage.courseProgress === 'NOT_STARTED'" class="badge badge-pill badge-danger">Not Accepted</span>
                              <span *ngIf="outage.courseProgress === 'IN_PROGRESS'" class="badge badge-pill badge-warning">Started - Not Accepted</span>
                              <span *ngIf="outage.courseProgress === 'EXPIRED'" class="badge badge-pill badge-primary">Completed - Inactive</span>
                              <span *ngIf="outage.courseProgress === 'COMPLETED'" class="badge badge-pill badge-success">Completed</span>
                            </td>
                            <td>{{ outage.lastModifiedDate | date: 'MMM d, y'}}</td>
                          </tr>
                          <tr [pSelectableRow]="outage"></tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" let-columns>
                          <tr>
                            <td [attr.colspan]="3">No outage acceptances assigned</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>
                <br>
              </ng-container>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Certificate" [(visible)]="showAddCertificateTypeModal" modal="true" [baseZIndex]="1000000"
  [style]="{ width: '90vw', maxWidth: '750px' }"
  [draggable]="false"
  [resizable]="false">

  <form *ngIf="!saveInProgress" [formGroup]="addCertificateForm" (ngSubmit)="onAddCertificateFormSubmit()">
    <div class="row my-4">
      <div class="col-md-12 mb-4" *ngIf="competencyTypes.length">
        <div class="form-group">
          <label>Select Certificate Type</label>
          <p><b>{{competencyToUpload?.label}}</b></p>
        </div>
      </div>
      <div class="col-md-12 mb-4" *ngIf="!competencyTypes.length">
        <label>Select Certificate Type</label>
        <p-dropdown class="form-control" placeholder="No competency types found. Try again later or contact support"></p-dropdown>
      </div>
      <div class="col-md-12 mb-4">
        <div class="form-group">
          <label>Expires <span class="required-text">(required)</span></label>
          <p-calendar
            class="form-control"
            formControlName="expires"
            dateFormat="dd/mm/yy"
            [yearNavigator]="true"
            [yearRange]="datepickerYearRange"
            [monthNavigator]="true"
            [minDate]="minDateValue"
            placeholder="Select Expiry Date"
            [showIcon]="true"
            [style]="{ width: '100%' }">
          </p-calendar>
        </div>
      </div>
      <div *ngIf="previousFiles.length" class="col-md-12">
        <div class="form-group">
          <label><b>Existing Files will be removed:</b></label>
          <div *ngFor="let file of previousFiles" class="d-flex">
            <p>{{file.fileName}}</p>
            <p>{{file.id}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="compFile" class="btn btn-primary btn-round">
            <span class="align-middle">
              <i class="pi pi-upload"></i></span> Browse Supporting Documents
          </label>
          <input
            type="file"
            class="form-control"
            name="compFile"
            id="compFile"
            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
            (change)="onFileChange($event)"
            multiple
            #fileInput
          />
          <ng-container *ngIf="selectedDocumentsArray.length">
            <p>Selected Documents:</p>
            <ul>
              <li *ngFor="let file of selectedDocumentsArray">{{ file.name }}</li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <div *ngIf="saveInProgress" style="width: 50%; margin: 0 auto">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-footer>
    <div class="my-4">
      <button type="button" (click)="showAddCertificateTypeModal = false" [disabled]="saveInProgress" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
      <button type="button" (click)="onAddCertificateFormSubmit()" [disabled]="!addCertificateForm.valid || !areFilesAdded || saveInProgress" class="my-2 btn btn-round btn-sm btn-success">Submit for Approval</button>
    </div>
  </p-footer>
</p-dialog>
